<template>
    <section
        role="alert"
        class="promo__view"
    >
        <img class="promo__view-img" :src="require('@/assets/icons/cashback-icon.svg')" alt="">
        <p class="promo__view-text">
            {{$t("ui.promo.a")}} {{ campaignDiscount }} {{$t("ui.promo.b")}}
        </p>
    </section>
</template>

<script>
import { computed } from "vue";

export default {
    name: "PromoView",

    emits: ["next"],

    props: {
        campaignInfo: {
            type: String,
            required: true,
        },
        currency: {
            type: String,
            default: "",
        },
    },
    setup(props) {
        const campaignDiscount = computed(() => {
            if (props.campaignInfo && props.campaignInfo.discount) {
                let discountedValue = props.campaignInfo.discount_type === "v" 
                    ? `${props.currency} ${props.campaignInfo.discount}`
                    : `${parseFloat(props.campaignInfo.discount) * 100}%`;

                return discountedValue;
            }
            return 0;
        });

        return {
            campaignDiscount,
        };
    },

};
</script>
<style lang="scss" scoped>
    .promo__view {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        margin-bottom: 25px;

        background: #2A3362;
        border-radius: 4px;

        &-img {
            margin-right: 7px;
            @media screen and (max-width: 280px) {
                display: none;
            }
        }

        &-text {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 14px;
            color: #FFFFFF;
            @include screen(min) {
                font-size: 12px;
            }
            @include screen(small) {
                font-size: 10px;
            }
            @include screen(smallest) {
                font-size: 9px;
            }
        }
    }
</style>